import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-188">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-189">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-190" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} role="dialog" aria-modal="true" aria-label={title} className="relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-191">
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 flex-shrink-0" data-id="element-192">
              <h2 className="text-xl font-bold text-[#1A1A1A]" data-id="element-193">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-[#5A5A5A] hover:text-[#1A1A1A]" aria-label="Cerrar" data-id="element-194">
                <X className="w-5 h-5" data-id="element-195" />
              </button>
            </div>

            <div className="px-6 py-6 overflow-y-auto text-[#5A5A5A] leading-relaxed text-sm space-y-4 flex-1" data-id="element-196">
              {children}
            </div>

            <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0" data-id="element-197">
              <button onClick={onClose} className="w-full py-3 bg-[#E8F5E2] text-[#2D5A27] font-semibold rounded-xl hover:bg-[#d4edcc] transition-colors text-sm" data-id="element-198">
                Cerrar
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}